module.exports = __webpack_public_path__ + "media/images/icons/google-reviews-e3792bc0ecde4150f1ae69ea59090646.svg";